"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Transaction_1 = require("../models/Transaction");
const Signature_1 = require("../models/Signature");
const User_1 = require("../models/User");
class TransactionSerializer {
    constructor(transactionTypeResolver) {
        this.transactionTypeResolver = transactionTypeResolver;
    }
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    dataToTransaction(data, local) {
        if (!data['u']) {
            throw new Error('Empty creator key');
        }
        if (!data['u']['l']) {
            throw new Error('Empty creator login');
        }
        if (!data['u']['pk']) {
            throw new Error('Empty creator public key');
        }
        if (!data['t']) {
            throw new Error('Empty type');
        }
        if (!data['p']) {
            throw new Error('Empty model payload');
        }
        if (!data['h']) {
            throw new Error('Empty hash');
        }
        const creator = new User_1.User(data['u']['l'], data['u']['pk']);
        const type = data['t'];
        const payloadSerializer = this.transactionTypeResolver.getPayloadSerializer(type);
        const model = payloadSerializer.fromPayloadToModel(data['p'], creator, local);
        const tx = new Transaction_1.Transaction(creator, type, model, data['h']);
        if (data['s']) {
            for (const signatureData of data['s']) {
                tx.signatures.push(new Signature_1.Signature(signatureData['sg'], signatureData['pk']));
            }
        }
        if (local && data['d']) {
            tx.storedAt = new Date(data['d']);
        }
        return tx;
    }
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    transactionToData(transaction, local) {
        const signatures = [];
        for (const signature of transaction.signatures) {
            signatures.push({
                'sg': signature.signature,
                'pk': signature.publicKey
            });
        }
        const payloadSerializer = this.transactionTypeResolver.getPayloadSerializer(transaction.type);
        /* eslint-disable  @typescript-eslint/no-explicit-any */
        const data = {
            'u': {
                'l': transaction.creator.login,
                'pk': transaction.creator.publicKey
            },
            't': transaction.type,
            'p': payloadSerializer.modelToPayload(transaction.model, local),
            'h': transaction.hash,
            's': signatures
        };
        if (local && transaction.storedAt) {
            data['d'] = transaction.storedAt.toISOString();
        }
        return data;
    }
}
exports.TransactionSerializer = TransactionSerializer;
